<template>
    <div class="text-h6 lighten-3 rounded-lg pa-4">
        {{question_title}} <small class="validate-warning">{{required_mark}}</small>
    </div>
</template>

<script>
export default {
  name: 'QuestionTitle',
  components: {
  },
  props: ['question_title', 'required_mark']
}
</script>
